import React from "react";
import { connect } from "react-redux";
import actioncable from "actioncable";
import moment from "moment";
import { CircularProgress } from "material-ui";
import CurrentWebinars from "containers/Dashboard/CurrentWebinars/CurrentWebinars";
import UpcomingWebinars from "containers/Dashboard/UpcomingWebinars/UpcomingWebinars";
import PreviousWebinars from "containers/Dashboard/PreviousWebinars/PreviousWebinars";
import ZoomInfo from "containers/Dashboard/ZoomInfo";
import actions from "actions";
import constants from "constants";
import DisciplineTagSelect from "containers/Input/DisciplineTagSelect";
import storage from "../../services/storage";

const ALL = "All";

const {
  loadUpcomingWebinarsSaga,
  loadCurrentWebinarsSaga,
  loadPreviousWebinarsSaga,
  loadSubscriptionsSaga,
  cleanWebinars,
  setProfileConfirmation,
  reloadDashboardWebinars,
  loadSponsorsSuggestionsSaga,
  setWebinars,
} = actions;

const { UPCOMING_WEBINARS, CURRENT_WEBINARS, PREVIOUS_WEBINARS } = constants;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTo: null,
      webinars: [1, 2, 3],
      page: {
        upcoming: 1,
        current: 1,
        previous: 1,
      },
      active: "",
      sponsor: ALL,
      disciplines: [],
    };

    this.actionCable = null;
    this.cable = null;
    this.timeout = null;
    this.loadingTimeout = null;
  }

  componentWillMount() {
    const slug = localStorage.getItem("_url_slug");

    if (slug) {
      localStorage.removeItem("_url_slug");
      this.props.router.push(`/${slug}`);
    }

    // this.props.loadSponsorsSuggestions();
    this.props.loadUpcomingWebinars(this.state.page.upcoming);
    this.props.loadCurrentWebinars(this.state.page.current);
    this.props.loadPreviousWebinars(this.state.page.previous);
    // this.setReloadInterval();
    
    // Safety timeout: If loading takes more than 30 seconds, force reload
    this.loadingTimeout = setTimeout(() => {
      if (this.props.isLoading) {
        console.warn("Loading timeout reached - forcing page reload");
        window.location.reload();
      }
    }, 30000);
  }

  connect = (token) => {
    // this.actionCable = actioncable.createConsumer(`/cable?token=${token}`); // ws://139.59.184.179:9000 - Test
    // this.subscribe();
  };

  connected = (data) => {
    console.log("CONNECTED -> ", data);
  };

  disconnected = (data) => {
    console.log("DISCONNECTED -> ", data);
  };

  receivedWebinar = ({ webinar, webinar_id, status }) => {
    const { setWebinars, current, upcoming, previous } = this.props;

    if (webinar) {
      const currentWebinarIndex = upcoming.values
        .map((upWebinar) => upWebinar.id)
        .indexOf(webinar.id);
      const upcomingWebinars = [...upcoming.values];
      const oldCurrentWebinars = current.values.filter(
        (currentWebinar) =>
          moment().isAfter(moment(currentWebinar.end_date)) ||
          moment(currentWebinar.end_date).isSame(moment())
      );
      const currentWebinars = current.values.filter((currentWebinar) =>
        moment().isBefore(moment(currentWebinar.end_date))
      );
      const allCurrentWebinars = [...[webinar], ...currentWebinars];
      const allPreviousWebinars = oldCurrentWebinars
        ? previous.values
        : [...oldCurrentWebinars, ...previous.values];

      upcomingWebinars.splice(currentWebinarIndex, 1);

      setWebinars(
        CURRENT_WEBINARS,
        allCurrentWebinars,
        allCurrentWebinars.length
      );
      setWebinars(UPCOMING_WEBINARS, upcomingWebinars, upcomingWebinars.length);
      setWebinars(
        PREVIOUS_WEBINARS,
        allPreviousWebinars,
        allPreviousWebinars.length
      );
    } else if (webinar_id && status === "finished") {
      const finishedCurrentWebinar = current.values.filter(
        (upWebinar) => upWebinar.id === webinar_id
      )[0];
      const currentWebinars = current.values.filter(
        (currentWebinar) => currentWebinar.id !== webinar_id
      );
      const allCurrentWebinars = currentWebinars;
      const allPreviousWebinars = finishedCurrentWebinar
        ? previous.values
        : [...finishedCurrentWebinar, ...previous.values];

      setWebinars(
        CURRENT_WEBINARS,
        allCurrentWebinars,
        allCurrentWebinars.length
      );
      setWebinars(
        PREVIOUS_WEBINARS,
        allPreviousWebinars,
        allPreviousWebinars.length
      );
    }
  };

  subscribe = () => {
    // if (this.actionCable)
    //   this.cable = this.actionCable.subscriptions.create({
    //     channel: `UserChannel`,
    //   }, {
    //     connected: this.connected,
    //     disconnected: this.disconnected,
    //     received: this.receivedWebinar,
    //   });
  };

  componentDidMount() {
    // const {session} = storage.getSessionData();

    // if (session.token)
    //   this.connect(session.token);

    if (this.props.location.query.scrollTo) {
      const index = this.props.upcoming.values.findIndex(
        (item) => item.id == this.props.location.query.scrollTo
      );
      if (index < 0) () => ({});
    }
    this.chekTime();
  }

  componentWillReceiveProps = (nextState) => {
    const { upcoming } = this.props;
    const { session } = storage.getSessionData();

    if (
      nextState.upcoming.count > this.props.upcoming.count &&
      this.props.location.query.scrollTo
    ) {
      const index = nextState.upcoming.values.findIndex(
        (item) => item.id == this.props.location.query.scrollTo
      );

      if (index < 0) this.nextPage(UPCOMING_WEBINARS);
      else
        this.setState((prev) => ({
          ...prev,
          scrollTo: this.props.location.query.scrollTo,
        }));
    }

    if (session.token && !this.actionCable) this.connect(session.token);

    if (upcoming.values.length !== nextState.upcoming.values) {
      this.chekTime();
    }

    // Clear loading timeout when loading completes
    if (this.props.isLoading && !nextState.isLoading && this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
    this.actionCable = null;
    clearInterval(this.timeout);
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }

  checkWebinar = () => {
    const { upcoming, setWebinars } = this.props;
    // console.log('Check ', moment().isSameOrAfter(moment(upcoming.values[0].start_date)), this.timeout);

    if (moment().isSameOrAfter(moment(upcoming.values[0].start_date))) {
      setWebinars(CURRENT_WEBINARS, [upcoming.values[0]], 1);
      clearInterval(this.timeout);
      // console.log('Clear ', this.timeout);
    }
  };

  chekTime = () => {
    const { current, upcoming } = this.props;
    const { values } = current || {};

    if (values.length === 0 && upcoming.values[0] && !this.timeout) {
      // console.log('chekTime ', this.timeout);
      this.timeout = setInterval(this.checkWebinar, 3000);
    }
  };

  reloadWebinars = () => {
    const params = this.webinarParams();
    this.props.reloadDashboardWebinars(params);
  };

  webinarParams = () => {
    // Only return group_id if it exists in props or state
    // All other filtering is now handled by the backend via the scope parameter
    const group_id = this.props.group_id || this.state.group_id;
    return group_id ? { group_id } : {};
  };

  setReloadInterval = () => {
    this.reloadInterval = setInterval(() => {
      this.reloadWebinars();
    }, 60000);
  };

  clearReloadInterval = () => {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  };

  nextPage = (webinarType) => {
    switch (webinarType) {
      case UPCOMING_WEBINARS:
        this.setState(
          {
            page: {
              ...this.state.page,
              upcoming: this.state.page.upcoming + 1,
            },
          },
          () => this.props.loadUpcomingWebinars(this.state.page.upcoming)
        );
        break;
      case CURRENT_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, current: this.state.page.current + 1 },
          },
          () => this.props.loadCurrentWebinars(this.state.page.current)
        );
        break;
      case PREVIOUS_WEBINARS:
        this.setState(
          {
            page: {
              ...this.state.page,
              previous: this.state.page.previous + 1,
            },
          },
          () => this.props.loadPreviousWebinars(this.state.page.previous)
        );
        break;
    }
  };

  hideProfileConfirmation = () => {
    this.props.hideProfileConfirmation();
  };

  changeActiveLink = (val) =>
    this.setState({
      active: val,
    });

  sponsorSuggestions = () => {
    const { sponsorOptions } = this.props;
    const sponsors = (sponsorOptions || []).map((sponsor) => ({
      value: sponsor.id,
      label: sponsor.title,
    }));

    return [...sponsors, { label: ALL, value: ALL }];
  };

  onFilterChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        page: {
          upcoming: 1,
          current: 1,
          previous: 1,
        },
      },
      this.reloadWebinars
    );
  };

  onDisciplinesChange = (disciplines) => {
    this.setState(
      {
        disciplines: (disciplines || []).map((discipline) => discipline.value),
        page: {
          upcoming: 1,
          current: 1,
          previous: 1,
        },
      },
      this.reloadWebinars
    );
  };

  renderFilters = () => {
    if (this.props.sponsor) {
      return null;
    }

    return (
      <div className="section_webinars_sponsors_filter">
        <DisciplineTagSelect
          onChange={this.onDisciplinesChange}
          value={this.state.disciplines}
        />
      </div>
    );
  };

  render() {
    const { isLoading } = this.props;


    return (
      <main className="site--width">
        <ZoomInfo />
        <div className="section_webinars">
          <h4 className="webinars_main_title">Meetings</h4>
          <ul className="section_webinars_list ">
            <li className="section_webinars_list_item tab">
              <a
                className={this.state.active == "current" && "active"}
                href="#current"
                onClick={() => this.changeActiveLink("current")}
              >
                CURRENT MEETINGS
              </a>
            </li>
            <li className="section_webinars_list_item tab">
              <a
                href="#upcoming"
                onClick={() => this.changeActiveLink("upcoming")}
                className={this.state.active == "upcoming" && "active"}
              >
                UPCOMING MEETINGS
              </a>
            </li>
            <li className="section_webinars_list_item tab">
              <a
                href="#previous"
                onClick={() => this.changeActiveLink("previous")}
                className={this.state.active == "previous" && "active"}
              >
                RECORDED MEETINGS
              </a>
            </li>
          </ul>
          {this.renderFilters()}
        </div>
        <CurrentWebinars
          webinars={this.props.current.values}
          nextPage={() => this.nextPage(CURRENT_WEBINARS)}
          page={this.state.page.current}
          count={this.props.current.count}
          onRefreshWebinars={this.reloadWebinars}
        />
        <UpcomingWebinars
          webinars={this.props.upcoming.values}
          nextPage={() => this.nextPage(UPCOMING_WEBINARS)}
          page={this.state.page.upcoming}
          count={this.props.upcoming.count}
          scrollTo={this.state.scrollTo}
        />
        <PreviousWebinars
          webinars={this.props.previous.values}
          nextPage={() => this.nextPage(PREVIOUS_WEBINARS)}
          page={this.state.page.previous}
          count={this.props.previous.count}
          sponsor={this.state.sponsor}
          sponsors={this.sponsorSuggestions()}
          onFilterChange={this.onFilterChange}
        />
        {isLoading && (
          <div className="dashboard-loader">
            <CircularProgress />
            <p>Reloading...</p>
          </div>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  upcoming: state.webinars[UPCOMING_WEBINARS],
  current: state.webinars[CURRENT_WEBINARS],
  previous: state.webinars[PREVIOUS_WEBINARS],
  // sponsorOptions: state.suggestions.sponsor.values,
  sponsorOptions: state.sponsors.list.values,
  isLoading: state.webinars.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentWebinars: (page) => dispatch(loadCurrentWebinarsSaga(page)),
  loadUpcomingWebinars: (page) => dispatch(loadUpcomingWebinarsSaga(page)),
  loadPreviousWebinars: (page) => dispatch(loadPreviousWebinarsSaga(page)),
  loadSubscriptions: () => dispatch(loadSubscriptionsSaga()),
  cleanWebinars: () => dispatch(cleanWebinars()),
  hideProfileConfirmation: () => dispatch(setProfileConfirmation(false)),
  reloadDashboardWebinars: () => dispatch(reloadDashboardWebinars()),
  loadSponsorsSuggestions: () => dispatch(loadSponsorsSuggestionsSaga()),
  setWebinars: (webinarsType, webinars, count) =>
    dispatch(setWebinars(webinarsType, webinars, count)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js